import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { Button, StandardDialog } from '@roc/ui';
import { useEffect, useState } from 'react';
import { Box, IconButton, TextareaAutosize } from '@material-ui/core';
import { ThumbDownOutlined, ThumbUpOutlined } from '@material-ui/icons';
import { ChatBotStore } from '../stores/chatBotStore';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
  },
  textarea: {
    width: '100%',
    padding: theme.spacing(1.5, 2),
    borderRadius: '12px',
    border: '2px solid #e2e8f0',
    fontFamily: theme.typography.fontFamily,
    fontSize: '15px',
    lineHeight: '1.5',
    resize: 'none',
    outline: 'none',
    transition: 'all 0.2s ease',
    boxSizing: 'border-box',
    '&:focus': {
      boxShadow: '0 0 0 3px rgba(33, 57, 94, 0.1)',
    },
    '&::placeholder': {
      color: '#94a3b8',
    },
  },
  thumbButtonsContainer: {
    marginTop: '2px',
    display: 'flex',
    justifyContent: 'center',
  },
  thumbButton: {
    marginRight: '4px',
    width: '30px',
    height: '30px',
    '& .MuiIconButton-label': {
      fontSize: '16px',
    }
  }
}));

interface GiveFeedBackDialogProps {
  isModalOpen: boolean;
  handleCloseModal: () => void;
  handleSubmit: () => void;
  store: ChatBotStore;
  messageId: string;
  buttonClicked?: 0 | 1 | null; // 1:like 0:dislike
}

export const GiveFeedBackDialog = observer(({ isModalOpen, handleCloseModal, handleSubmit, store, messageId, buttonClicked }: GiveFeedBackDialogProps) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (!isModalOpen) {
      setInputValue('');
    }
  }, [isModalOpen]);

  const submitFeedback = () => {
    store.sendMessageFeedback(messageId, inputValue, buttonClicked!);
    handleSubmit();
  }

  const getContent = () => {
    return (
      <Box className={classes.container}>
        <TextareaAutosize
          className={classes.textarea}
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          placeholder={'Enter your feedback here...'}
          minRows={2}
          maxRows={4}
        />
      </Box>
    );
  }
  return (
    <>
      <StandardDialog
        open={isModalOpen}
        title={`Give Feedback`}
        maxWidth="xs"
        handleClose={handleCloseModal}
        dialogContent={getContent}
        fullScreen={false}
        dialogActions={(
          <>
            <Button
              style={{ marginRight: '8px' }}
              onClick={handleCloseModal}
              color="primary"
              variant="outlined"
              testId="cancel"
            >
              Cancel
            </Button>
            <Button
              onClick={submitFeedback}
              color="primary"
              variant="contained"
              testId="submit"
            >
              Submit
            </Button>
          </>
        )}
      />
    </>
  );
});

interface ThumbButtonsProps {
  messageId: string;
  store: ChatBotStore;
}

export const ThumbButtons = observer(({ messageId, store }: ThumbButtonsProps) => {
  const classes = useStyles();
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [buttonClicked, setButtonClicked] = useState<0 | 1 | null>(null);


  return (
    <>
      <Box className={classes.thumbButtonsContainer} >
        <IconButton
          onClick={() => {
            setIsFeedbackModalOpen(true);
            setButtonClicked(1);
          }}
          color="primary"
          className={classes.thumbButton}
        >
          <ThumbUpOutlined />
        </IconButton>
        <IconButton
          onClick={() => {
            setIsFeedbackModalOpen(true);
            setButtonClicked(0);
          }}
          color="secondary"
          className={classes.thumbButton}
        >
          <ThumbDownOutlined />
        </IconButton>
      </Box>
      <GiveFeedBackDialog
        isModalOpen={isFeedbackModalOpen}
        handleCloseModal={() => setIsFeedbackModalOpen(false)}
        handleSubmit={() => setIsFeedbackModalOpen(false)}
        store={store}
        messageId={messageId}
        buttonClicked={buttonClicked}
      />
    </>
  );
});
